module.exports = __webpack_public_path__ + "img/placeholder.f067fde7.jpg";